<template>
  <div>
    <div>
      <div class="form-actions flex justify-between">
        <div class="float-right flex">
          <!-- <vx-tooltip text="Add promo" position="top">
            <vs-button
              class="iconOnly"
              color="dark"
              type="flat"
              icon-pack="feather"
              icon="icon-plus"
              @click="addPromo()"
            ></vs-button>
          </vx-tooltip>

          <vx-tooltip text="Edit promo(s)" position="top">
            <vs-button
              class="iconOnly"
              color="dark"
              type="flat"
              icon-pack="feather"
              icon="icon-edit"
              @click="editPromo()"
              :disabled="this.selectedRowCount == 0"
            ></vs-button>
          </vx-tooltip>

          <vx-tooltip text="Duplicate promo" position="top">
            <vs-button
              class="iconOnly"
              color="dark"
              type="flat"
              icon-pack="feather"
              icon="icon-copy"
              @click="duplicatePromo()"
              :disabled="this.selectedRowCount !== 1"
            ></vs-button>
          </vx-tooltip> -->
          <vx-tooltip text="Open All MIS" position="top">
            <vs-button
              class="iconOnly"
              color="dark"
              type="flat"
              icon-pack="feather"
              icon="icon-corner-up-right"
              @click="$router.push('/promos/lists')"
            ></vs-button>
          </vx-tooltip>
        </div>
      </div>
      <div class="scrollable-area">
        <div id="grid-loader" class="vx-card vs-con-loading__container">
          <ag-grid-vue
            id="autoHeightGrid"
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 mb-4 ag-grid-table"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :components="components"
            :rowData="tableData"
            rowSelection="multiple"
            :enableRangeSelection="true"
            :suppressCopyRowsToClipboard="true"
            :suppressDragLeaveHidesColumns="true"
            :animateRows="false"
            :floatingFilter="true"
            :pagination="false"
            :paginationPageSize="paginationPageSize"
            :suppressPaginationPanel="true"
            :suppressRowClickSelection="true"
            :rowClassRules="rowClassRules"
            :statusBar="statusBar"
            :sideBar="sideBar"
            :rowHeight="45"
            :headerHeight="30"
            :floatingFiltersHeight="45"
            :checkboxSelection="true"
            :domLayout="domLayout"
            @row-selected="onRowSelected"
            @pagination-changed="onPaginationChanged"
            @column-resized="onColumnResized"
          >
          </ag-grid-vue>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import "@/assets/scss/radix/extraComponents/agGridStyleOverride.scss";

import CellRendererStatus from "@/components/ag-grid-tables/actions/CellRendererStatus.vue";
import EditMISPromo from "@/components/ag-grid-tables/promos/EditMISPromo.vue";

export default {
  name: "MISPromoClientComponent",
  components: {
    AgGridVue,
    CellRendererStatus,
    EditMISPromo,
  },
  props: {
    expired: {
      type: Boolean,
      default: false,
    },
    resellerid: {
      type: Number,
      default: null,
    },
    filteredData: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      selectedRowCount: "",
      rejectedPromo: false,
      activePrompt: false,
      reject_comments: "",
      autoGroupColumnDef: null,
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      domLayout: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        suppressMovable: false,
        filterParams: {
          suppressAndOrCondition: true,
          newRowsAction: "keep",
        },
      },
      rowClassRules: null,
      statusBar: null,
      sideBar: null,
      columnDefs: null,
      tableData: null,
      selectedPromos: [],
      flags: {
        selectedAll: false,
      },
      // Cell Renderer Components
      components: {
        CellRendererStatus,
      },
      globalSearchTerm: "",
      selectedNonEditableRow: false,
    };
  },
  watch: {
    windowWidth(val) {
      // Toggle colummn movable
      this.toggleColumnMovable(val);
      // Toggle colummn pinning
      this.toggleColumnPinned(val);
    },
    resellerid(val) {
      this.populateTableData();
    },
    filteredData(val) {
      if (val !== null) {
        this.tableData = val;
      } else {
        this.populateTableData();
      }
    },
  },
  computed: {
    windowWidth: function () {
      return this.$store.state.windowWidth;
    },
    user_role() {
      return JSON.parse(localStorage.getItem("userDetails")).role;
    },
    user_id() {
      return JSON.parse(localStorage.getItem("userDetails")).id;
    },
    status() {
      // console.log(data && data ? data.status:'');
      return event.node;
    },
    paginationPageSize() {
      if (this.gridApi) {
        return this.gridApi.paginationGetPageSize();
      } else {
        return 15;
      }
    },
    totalPages() {
      if (this.gridApi) {
        return this.gridApi.paginationGetTotalPages();
      } else {
        return 0;
      }
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
    validComment() {
      return this.reject_comments.length > 0;
    },
    rejectTitle() {
      return "Reject Selected Promos?";
    },
    yesText() {
      return "Yes";
    },
    noText() {
      return "No";
    },
  },
  methods: {
    onPageSizeChanged(newPageSize) {
      var value = document.getElementById("page-size").value;
      this.gridApi.paginationSetPageSize(Number(value));
    },
    onPaginationChanged() {
      // console.log('pagechanges');
      if (this.gridApi) {
        (this.totalRows = this.gridApi.paginationGetRowCount()),
          (this.currentPageSize = this.gridApi.paginationGetPageSize());
      }
    },

    setAutoHeight() {
      this.gridApi.setDomLayout("autoHeight");
      // auto height will get the grid to fill the height of the contents,
      // so the grid div should have no height set, the height is dynamic.
      document.querySelector("#autoHeightGrid").style.height = "";
    },

    onRowSelected(event) {
      var getStatus = this.gridApi
        .getSelectedNodes()
        .map((x) => x.data)
        .map((x) => x.status);
      getStatus.includes("expired")
        ? (this.selectedNonEditableRow = true)
        : (this.selectedNonEditableRow = false);
      if (event.node.selected) {
        // Push to selectedPromos
        this.selectedRowCount = this.gridApi.getSelectedNodes().length;
      } else {
        // Remove from selectedPromos
        // this.removeFromArray(this.selectedPromos, event.node.childrenAfterGroup[0].data, 'id');
        this.selectedRowCount = this.gridApi.getSelectedNodes().length;
      }
    },
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#div-with-loading",
        scale: 0.8,
      });
    },
    hideLoadingInDiv() {
      this.$vs.loading.close("#div-with-loading > .con-vs-loading");
    },
    scrollHanle(evt) {
      // console.log(evt)
    },
    toggleColumnMovable(val) {
      if (val <= 576) {
        this.defaultColDef["suppressMovable"] = true;
      } else {
        this.defaultColDef["suppressMovable"] = false;
      }
    },
    toggleColumnPinned(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("domain", null);
      } else {
        this.gridOptions.columnApi.setColumnPinned("domain", "left");
      }
    },
    onColumnResized() {
      this.gridApi.resetRowHeights();
    },
    sizeColumnsToFit() {
      this.gridApi.sizeColumnsToFit();
    },
    disableQueue() {
      this.rowClassRules = {
        // "ag-row-disabled": 'data && (data.status == "edit pending")',
        // "ag-checkbox-disabled": 'data && (data.status == "edit pending")',
        // "ag-row-red": 'data && (data.status == "expired")',
      };
    },
    refreshPage() {
      // this.$root.$emit('refreshPage');
      // Reset filters
      // this.gridApi.setFilterModel(null);
      // Reset selection
      this.gridApi.deselectAll();
      // Reset sort
      this.gridApi.setSortModel(null);
      // Table Data AXIOS Call
      this.populateTableData();
    },
    refreshPageWithFilters() {
      this.flags["selectedAll"] = false;
      // Reset filters
      this.gridApi.setFilterModel(null);
      // Reset selection
      this.gridApi.deselectAll();
      // Reset sort
      this.gridApi.setSortModel(null);
      // Table Data AXIOS Call
      this.populateTableData();
    },
    populateTableData() {
      let self = this;
      /* FIXME: Demo Functionality */

      var am_id = JSON.parse(localStorage.getItem("userDetails")).id;
      // role = JSON.parse(localStorage.getItem("userDetails")).role;
      let url =
        // "/mis-records/" + this.resellerid + "/" + am_id + "/" + role;
        "/mis-records/" + this.resellerid + "/" + am_id;

      if (this.filteredData !== null) {
        this.tableData = this.filteredData;
      } else {
        /* Get table data for std-promo-req */
        this.$axiosSecure
          .get(url)
          .then((response) => {
            this.tableData = response.data;
          })
          .catch((error) => {
            // Error notification
            self.$vs.notify({
              color: "danger",
              title: "Something went wrong",
              text: "Please contact the server admin",
            });

            console.log(error);
            this.tableData = [];

            // Clear Listing Count
            this.$store.dispatch("clearListingCount");
          });
      }
    },
    gridSelectAll() {
      this.gridApi.forEachNodeAfterFilter((node) => {
        // console.log(node.data);
        if (
          !(
            node.data.status == "new approved" ||
            node.data.status == "rejected" ||
            node.data.status == "error"
          )
        ) {
          if (this.selectAll) {
            // Unselect the node
            node.setSelected(false);
            // console.log('node', node);
          } else {
            // Select the node
            node.setSelected(true);
            var selectedRowId = node.data.id;
            // console.log("selectAll", selectedRowId);
          }
        } else {
          // console.log('node', node.data.status);
        }
      });
    },
    addPromo() {
      // this.$router.push("/add-promo");
      let route = this.$router.resolve({ path: "/add-promo" });
      window.open(route.href);
    },
    editPromo() {
      let extended = false;

      if (this.expired) {
        extended = true;
      }

      var selectedRowsData = this.gridApi.getSelectedNodes().map((x) => x.data);
      this.$root.$emit("selectedGroupEditMIS", selectedRowsData, extended);
    },
    duplicatePromo() {
      // console.log('selected', this.gridApi.getSelectedNodes());
      // console.log("selected data", this.gridApi.getSelectedNodes());
      var selectedRowsData = this.gridApi.getSelectedNodes().map((x) => x.data);
      // this.$root.$emit('selectedDuplicate', selectedRowsData);
      this.$root.$emit("duplicatePromoMIS", selectedRowsData);
    },
    downloadData() {
      this.$root.$emit("downloadMISPage");
    },
    toggleSelectAll() {
      if (this.flags["selectedAll"]) {
        this.gridApi.deselectAll();
        this.flags["selectedAll"] = !this.flags["selectedAll"];
      } else {
        this.gridApi.selectAll();
        this.flags["selectedAll"] = !this.flags["selectedAll"];
      }
    },
  },
  beforeMount() {
    this.disableQueue();

    // Table Data AXIOS Call
    this.populateTableData();

    // Reset movable columns on mobile
    this.toggleColumnMovable(this.windowWidth);

    (this.columnDefs = [
      {
        headerName: "Client Name",
        field: "reseller.name",
        filter: "agSetColumnFilter",
        minWidth: 175,
        cellClass: "cellCustomWrap",
        checkboxSelection:
          this.user_role == "admin" ||
          this.user_role == "superadmin" ||
          this.user_role == "user" ||
          this.user_role == "biops",
        pinned: "left",
      },
      {
        headerName: "Type",
        field: "type",
        filter: "agTextColumnFilter",
        minWidth: 170,
        pinned: "left",
      },
      {
        headerName: "TLD",
        field: "tld.tld_name",
        filter: "agSetColumnFilter",
        minWidth: 100,
        width: 150,
        pinned: "left",
      },
      {
        headerName: "Status",
        field: "status",
        filter: "agSetColumnFilter",
        cellRendererFramework: "CellRendererStatus",
        minWidth: 100,
      },
      {
        headerName: "AM",
        field: "am.name",
        filter: "agSetColumnFilter",
        minWidth: 175,
        width: 175,
      },
      {
        headerName: "Effective 1Yr Price",
        field: "effective_first",
        // filter: "agSetColumnFilter",
        minWidth: 150,
        cellRenderer: (data) => {
          // console.log('data', data.data);
          // this.number();
          if (data.data.type.includes("premium")) {
            return "<div>" + data.data.effective_first_per + "%</div>";
          } else {
            return "<div>$" + data.data.effective_first + "</div>";
          }
        },
      },
      {
        headerName: "Effective Multi-Yr Price",
        field: "effective_multi",
        // filter: "agSetColumnFilter",
        minWidth: 150,
        cellRenderer: (data) => {
          // this.number();
          if (data.data.type.includes("premium")) {
            return "<div>" + data.data.effective_multi_per + "%</div>";
          } else {
            return "<div>$" + data.data.effective_multi + "</div>";
          }
        },
      },
      {
        headerName: "Start Date",
        field: "start_date",
        filter: "agDateColumnFilter",
        minWidth: 175,
        filterParams: {
          comparator: function (filterLocalDateAtMidnight, cellValue) {
            let dateAsString = cellValue;
            if (dateAsString == null) return -1;
            let dateParts = dateAsString.split("-");
            let cellDate = new Date(
              Number(dateParts[0]),
              Number(dateParts[1]) - 1,
              Number(dateParts[2])
            );
            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
              return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
          },
          browserDatePicker: true,
        },
      },
      {
        headerName: "End Date",
        field: "end_date",
        filter: "agDateColumnFilter",
        minWidth: 175,
        filterParams: {
          comparator: function (filterLocalDateAtMidnight, cellValue) {
            let dateAsString = cellValue;
            if (dateAsString == null) return -1;
            let dateParts = dateAsString.split("-");
            let cellDate = new Date(
              Number(dateParts[0]),
              Number(dateParts[1]) - 1,
              Number(dateParts[2])
            );
            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
              return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
          },
          browserDatePicker: true,
        },
      },
      {
        headerName: "Period (Yrs)",
        field: "period",
        filter: "agSetColumnFilter",
        minWidth: 120,
      },
      {
        headerName: "List Based",
        field: "list_based",
        filter: "agSetColumnFilter",
        minWidth: 120,
        // hide:true
      },
    ]),
      // Set Grid sidebar
      (this.sideBar = {
        toolPanels: [
          {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
            toolPanelParams: {
              suppressRowGroups: true,
              suppressValues: true,
              suppressPivots: true,
              suppressPivotMode: true,
              suppressSideButtons: true,
              suppressColumnSelectAll: true,
              suppressColumnExpandAll: true,
            },
          },
        ],
      });
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    //agigrid loader
    this.gridApi.showLoadingOverlay();

    // Resize to fit columns
    this.sizeColumnsToFit();

    //set Auto height
    this.setAutoHeight();

    // Reset pinned columns on mobile
    this.toggleColumnPinned(this.windowWidth);

    // Page Refresh Event
    // this.$root.$on("refreshPage", () => {
    //   // Reset filters
    //   this.gridApi.setFilterModel(null);
    //   // Reset selection
    //   this.gridApi.deselectAll();
    //   // Reset sort
    //   this.gridApi.setSortModel(null);
    //   // Table Data AXIOS Call
    //   this.populateTableData();
    // });

    // Page Download Event
    this.$root.$on("downloadMISPage", () => {
      // AgGrid CSV Export
      this.gridApi.exportDataAsCsv();
    });

    // this.$root.$on("editPromoRequest", (rowData) => {
    //   // console.log(rowData.node.parent);
    //   // this.editPromoRequestPopup= true;
    //   this.formData['editRowData']= rowData.node.parent;
    // });

    // this.$root.$on("deletePromoRequest", (rowData) => {
    //   //console.log(rowData.node.parent);
    //   this.openDeletePromoConfirm(rowData.node.parent);
    // });

    this.$root.$on("tableRefresh", () => {
      // console.log('refresh');
      this.refreshPage();
    });
  },
  destroyed() {
    // Clear Listing Count
    this.$store.dispatch("clearListingCount");

    // Unbind Button Event Listeners
    this.$root.$off("tableRefresh");
  },
  beforeDestroy() {
    if (this.$refs.vsCollapseItem) {
      for (let collapseItem of this.$refs.vsCollapseItem) {
        window.removeEventListener("resize", collapseItem);
      }
    }
  },
};
</script>

<style lang="scss">
.ag-selection-checkbox {
  display: flex;
  align-items: center;
  height: 36px;
}

.ag-row-disabled,
.ag-checkbox-disabled .ag-group-checkbox {
  pointer-events: none;
}

.ag-row-disabled .ag-group-checkbox,
.ag-checkbox-disabled .ag-group-checkbox {
  opacity: 0.3;
}

.ag-row-level-1 .ag-group-value,
.text-capitalize input {
  text-transform: capitalize;
}

//Hide grouping arrow
.ag-group-expanded,
.ag-group-contracted {
  display: none !important;
}

.ag-group-checkbox {
  margin-left: 0 !important;
}

.text-capitalize {
  text-transform: capitalize;
}
.ag-row-red {
  background: #fff1ef;
}
</style>
